import React from "react";
import Meta from "../Meta";
import PageHeader from "../components/PageHeader";
import Loader from "../loader";
import AbonnementsRender from "../../Ummah/Abonnements/abonnement";
import { t } from "@lingui/core/macro";

const styles = `
.t26-abonnements-page {
  padding: 0 clamp(16px, 4vw, 32px) clamp(40px, 6vw, 80px);
  max-width: var(--container);
  margin-inline: auto;
}
`;

export default function Abonnements({ context, loading }) {
    const { org } = context;
    if (loading) {
        return (
            <>
                <Meta context={context} title={t`Abonnements de ${org.name}`} />
                <Loader />
            </>
        );
    }
    return (
        <>
            <Meta context={context} title={t`Abonnements de ${org.name}`} description={t`Abonnements et cotisations de ${org.name}`} />
            <style dangerouslySetInnerHTML={{ __html: styles }} />

            <PageHeader
                title={t`Abonnements`}
                subtitle={t`Nos formules de cotisation`}
                crumbs={[
                    { label: t`Accueil`, url: org.BASE_WEB_URL },
                    { label: t`Abonnements` },
                ]}
            />

            <div className="t26-abonnements-page">
                <AbonnementsRender context={context} />
            </div>
        </>
    );
}
